(function () {
  'use strict';

  angular.module('app').component('confirmBooking', confirmBooking());

  function confirmBooking() {
    return {
      bindings: {
        booking: '=',
        onBookingConfirmed: '&',
      },
      controller: ConfirmBookingComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/bookings/components/confirm-booking/confirm-booking.component.html',
    };
  }

  ConfirmBookingComponent.$inject = ['UtilService', 'BookingService'];

  function ConfirmBookingComponent(UtilService, BookingService) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    // Methods
    vm.saveConfirmBooking = saveConfirmBooking;

    function saveConfirmBooking(isFormValid) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.formErrors = true;
        return;
      }

      // console.log(vm.booking);
      // return;

      vm.sendingForm = true;
      BookingService.updateBookingStatus(vm.booking, 'confirmed', vm.confirmReason).then(function (
        data
      ) {
        if (!data.errors) {
          vm.onBookingConfirmed({ bookingObj: data });
        }

        vm.sendingForm = false;
      });
    }
  }
})();
